/* src/app/components/app-toolbar-venue-info/app-toolbar-venue-info.component.scss */
.wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline: 24px;
}
.info-section {
  display: flex;
}
.info-section .name {
  display: flex;
  align-items: center;
}
.info-section .name h3 {
  font-size: 14px;
}
.info-section .name div {
  background: var(--ion-color-primary);
  padding: 3px;
  font-size: 8px;
  border-radius: 50px;
  color: white;
  margin-left: 10px;
}
.info-section .info {
  display: flex;
  align-items: center;
}
.info-section .info p {
  font-size: 12px;
  font-family: AppFont, sans-serif;
}
.info-section .info ion-icon {
  width: 15px;
  padding-left: 10px;
}
ion-icon {
  cursor: pointer;
}
.logo {
  height: 30px;
  width: 90px;
}
.right-slot,
.left-slot {
  width: 54px;
}
/*# sourceMappingURL=app-toolbar-venue-info.component.css.map */
